
import { Control, FieldError, UseFormRegister } from 'react-hook-form';
import { HTMLInputTypeAttribute } from 'react';

import Input from '../Input';
import CountrySelect from '../Input/CountrySelect';
import { TFormFieldDefinition } from './types';

export interface FieldRendererProps {
  name: string;
  field: TFormFieldDefinition;
  control: Control;
  register?: UseFormRegister<any>;
  error?: FieldError;
}

const inputLikeTypes: Record<string, HTMLInputTypeAttribute> = {
  string: 'text',
  email: 'email',
  tel: 'tel',
  url: 'url',
  number: 'number',
  date: 'date',
};

const renderFieldComponent = ({ name, field, control, register, error }: FieldRendererProps) => {

  // Native input types
  if (field.type in inputLikeTypes) {
    return (
      <Input
        key={name}
        name={name}
        type={inputLikeTypes[field.type]}
        label={field.title}
        placeholder={field.placeholder}
        error={error}
        submit={register}
        hint={field.description}
      />
    );
  }

  // Our input field types
  switch (field.type) {
    case 'country':
      return (
        <CountrySelect
          key={name}
          name={name}
          label={field.title}
          control={control}
          error={error}
        />
      );

    case 'textarea':
      return (
        <Input.Textarea
          key={name}
          name={name}
          label={field.title}
          placeholder={field.placeholder}
          error={error}
          control={control}
        />
      );

    case 'select':
      return (
        <Input.Select
          key={name}
          name={name}
          label={field.title}
          control={control}
          error={error}
          options={(field.options || []).map((opt) => ({ label: opt, value: opt }))}
          placeholder={field.placeholder}
        />
      );

    case 'radio':
      return (
        <Input.RadioButtonGroup
          key={name}
          name={name}
          label={field.title}
          control={control}
          options={(field.options || []).map((opt) => ({ label: opt, value: opt }))}
          error={error}
        />
      );

    case 'checkbox':
      return (
        <Input.Checkbox
          key={name}
          name={name}
          label={field.title}
          control={control}
          error={error}
          submit={register}
        />
      );

    default:
      return null;
  }
};

export default renderFieldComponent;
